import { FunctionComponent } from 'react'

type ChosenInputMethod = 'Drag' | 'Gyro'

interface LookHowPopupProps {
  chosenInputMethod : ChosenInputMethod
}

const LookHowPopup : FunctionComponent<LookHowPopupProps> = (props) => {
  return (
    <div className="bottom-[120px] left-0 right-0 absolute grid pointer-events-none content-center">
      <div className='text-white text-center'>
        {/* TODO: The following is place holder and should be replaced when able */}
        {props.chosenInputMethod === 'Drag' && <p>Drag your finder around the screen to look around the room</p>}
        {props.chosenInputMethod === 'Gyro' && <p>Move your phone around to look around the room</p>}
      </div>
    </div>
  )
}

export default LookHowPopup
